// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bf4ad641","239":"af0dd51c","732":"4e5d683f"}[chunkId] + ".chunk.js";
};